module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "withContent": true,
      "maxWidth": 'default'
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.trads.title))]), _vm._v(" "), _c('section', [_c('TextInputBloc', {
    attrs: {
      "min-length": _vm.MIN_LENGTH_NAME,
      "required": true,
      "label": _vm.trads.label
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.template.name = $$v
      },
      expression: "template.name"
    }
  })], 1), _vm._v(" "), _c('section', [_c('h1', [_vm._v(_vm._s(_vm.trads.infos.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(((_vm.trads.infos.zone) + ": " + (_vm.template.zone.name))))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(((_vm.trads.infos.standDesign) + ": " + (_vm.template.standDesign.name))))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(((_vm.trads.infos.height) + ": " + (_vm.template.height))) + "mm")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(((_vm.trads.infos.width) + ": " + (_vm.template.width))) + "mm")])]), _vm._v(" "), _c('footer', {
    staticClass: "txtCenter"
  }, [_c('ClientColorButton', {
    attrs: {
      "disabled": _vm.$v.template.$invalid
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7398ab9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/ModalSavePlanoAsTemplate.vue
// module id = 3270
// module chunks = 0